export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Buscar',
  catalogHeaderTitle: 'Detalles',
  catalogDetailsCurtainCopyOptionTitle: 'Copiar enlace',
  catalogDetailsLinkCopiedAlertText: 'Enlace copiado!',
  catalogDetailsCurtainFlagOptionTitle: 'Reportar contenido',
  catalogDetailsFlagCurtainTitle: 'Reportar',
  catalogReportedCurtainContent: 'Contenido reportado',
  catalogWantBuy: 'Quieres comprar {item} de {app}',
  catalogInterestedIn: '{link}'
}
